<template>
  <div class="m-the-modal-support-content-wrapper">
    <div class="m-the-modal-support m-the-modal-support-content">
        <header class="m-the-modal-support-header">
          <AtomButtonTheModalCloseIcon/>
        </header>
        <section
          v-if="showLoading"
          class="m-the-modal-support-section"
        >
          <MoleculeSupportModalSkeleton/>
        </section>
        <section
          v-else
          class="m-the-modal-support-section"
        >
          <div class="m-the-modal-support-video-wrapper">
            <div :class="section.video.class">
              <iframe
                :src="section.video.src"
                :alt="section.video.alt"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
              >
              </iframe>
            </div>
          </div>

          <div class="m-the-modal-support-bottom-info">
            <p v-show="section.download.text && !footer.info.show">
              <a
                href="#"
                :class="section.download.class"
                @click.prevent="downloadFile(section.download.src)"
              >
                <i :class="section.download.icon"></i> {{ section.download.text }}
              </a>
            </p>
            <p
              v-show="section.info.text && !footer.info.show"
              class="margin-left-auto"
            >
              <a
                :class="section.info.class"
                :href="section.info.link"
                target="_blank"
                >
                  {{ section.info.text }}
              </a>
            </p>
          </div>

          <div
            v-if="section.gallery.thumbnail.length && !footer.info.show"
            class="m-the-modal-support-gallery"
          >
            <div class="m-the-modal-support-gallery-wrapper">
              <div
                v-for="(thumbnail, index) in section.gallery.thumbnail"
                :key="index"
                @click="changeVideo(thumbnail.src)"
                style="cursor: pointer;"
              >
                <img
                  class="m-the-modal-support-gallery-thumbnail"
                  :src="thumbnail.thumbnail"
                  :alt="thumbnail.alt"
                />
              </div>
            </div>
          </div>
        </section>
        <footer
          v-if="!showLoading"
          class="m-the-modal-support-footer"
        >
          <p
            class="m-the-modal-support-footer-info"
            v-show="footer.info.show"
          >
            <u>{{ footer.info.first }}</u> {{ footer.info.second }}
          </p>
          <AtomButtonSecondary
            v-show="!footer.info.show"
            :class="buttonSecondary.link.class"
            :button-secondary="buttonSecondary.link"
            @openTutorial="openTutorial"
          />
          <AtomButtonSecondary
            v-show="!footer.info.show"
            :class="buttonSecondary.change.class"
            :button-secondary="buttonSecondary.change"
            @changeToSupport="changeToSupport"
          />
          <AtomButtonSecondary
            v-show="footer.info.show"
            :class="buttonSecondary.support.class"
            :button-secondary="buttonSecondary.support"
            @openZendesk="openZendesk"
          />
        </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeSupportModal',

  components: {
    MoleculeSupportModalSkeleton: () => import('@/components/molecules/MoleculeSupportModalSkeleton')
  },

  data () {
    return {
      buttonSecondary: {
        link: {
          class: 'a-button-support-link',
          component: '',
          icon: 'fas fa-play',
          method: 'openTutorial',
          src: '',
          text: '¿Te gustraía descubrir más información?',
          type: 'button'
        },

        change: {
          class: 'a-button-support-support',
          component: '',
          icon: 'fas fa-pencil',
          method: 'changeToSupport',
          text: 'Escribir a soporte',
          type: 'button'
        },

        support: {
          class: 'a-button-support-support',
          component: '',
          icon: 'fas fa-pencil',
          method: 'openZendesk',
          text: 'Escribir ahora a soporte',
          type: 'button'
        }
      },

      footer: {
        info: {
          first: 'Mira este vídeo',
          second: 'así te resultará más fácil recibir ayuda.',
          show: false
        }
      },

      section: {
        video: {
          src: '',
          alt: '',
          class: 'm-the-modal-support-video'
        },

        gallery: {
          class: 'm-the-modal-support-gallery',
          thumbnail: []
        },

        download: {
          class: 'm-the-modal-support-download',
          src: '',
          text: '',
          icon: 'far fa-file-alt'
        },

        info: {
          class: 'm-the-modal-support-info',
          link: '',
          text: ''
        }
      },

      showLoading: true,

      supportVideo: {
        src: '',
        alt: 'Video de cómo pedir ayuda a soporte'
      }
    }
  },

  created () {
    this.getVideoTutorialFile()
  },

  methods: {
    changeToSupport () {
      this.showLoading = true
      this.getVideoTutorialFileData('soporte.js')
    },

    changeVideo (src) {
      const match = src.match(/vimeo\.com\/(\d+)/)
      const videoId = match[1]
      this.section.video.src = `https://player.vimeo.com/video/${videoId}?badge=0&autopause=0&player_id=0&app_id=58479`
    },

    downloadFile (urlFile) {
      const filename = decodeURIComponent(urlFile.split('/').pop())
      const link = document.createElement('a')
      link.href = urlFile
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    async getVimeoThumbnail (url) {
      const match = url.match(/vimeo\.com\/(\d+)/)
      if (!match) return null

      const videoId = match[1]
      const apiUrl = `https://vimeo.com/api/v2/video/${videoId}.json`

      try {
        const response = await fetch(apiUrl)
        const data = await response.json()
        return data[0].thumbnail_large // También puedes usar thumbnail_small o thumbnail_medium
      } catch (error) {
        console.error('Error obteniendo la miniatura:', error)
        return null
      }
    },

    getVideoTutorialFile () {
      var url = this.$route.fullPath

      // Eliminar el dominio y obtener solo la ruta
      var urlPath = url.replace(/^https?:\/\/[^\/]+\/?/, '').replace(/^\/+/, '')

      // Si la URL es la raíz, el archivo se llamará "home.js"
      if (!urlPath || urlPath === '') {
        urlPath = 'home'
      } else if (urlPath === `${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.paymentMethods.subject')}/${this.$t('mEditionMenu.billing.paymentMethods.children.connectMethod.subedition')}`) {
        urlPath = `${urlPath}/${this.$store.getters.getBillingPaymentMethod.nombre}`.toLowerCase().replace(/\s+/g, '')
      } else if (urlPath === `${this.$t('rPaths.academy')}/${this.$t('mEditionMenu.academy.autoresponders.subject')}/${this.$t('mEditionMenu.academy.autoresponders.children.connectAutoresponder.subedition')}`) {
        urlPath = `${urlPath}/${this.$store.getters.getAcademyAutoresponder.nombre}`.toLowerCase().replace(/\s+/g, '')
      }

      // Expresión regular para detectar UUIDs (tanto reales como placeholders {{uuid}})
      var uuidRegex = /([a-f0-9]{8}-?[a-f0-9]{4}-?[a-f0-9]{4}-?[a-f0-9]{4}-?[a-f0-9]{12})|(\{\{uuid\}\})/gi

      // Reemplazar cualquier UUID detectado por un guion bajo
      urlPath = urlPath.replace(uuidRegex, '_')

      // Reemplazar múltiples guiones bajos consecutivos por uno solo
      urlPath = urlPath.replace(/_+/g, '_')

      // Reemplazar "/" por "_" y eliminar caracteres especiales
      urlPath = urlPath.replace(/\//g, '_').replace(/[^a-zA-Z0-9_]/g, '') + '.js'

      // return urlPath
      this.getVideoTutorialFileData(urlPath)
    },

    async getVideoTutorialFileData (urlPath) {
      try {
        const timestamp = new Date().getTime()
        const module = await import(/* webpackIgnore: true */
          `https://d235bxvveiwz2r.cloudfront.net/${urlPath}?t=${timestamp}`)
        if (urlPath === 'soporte.js') {
          this.supportVideo = Object.assign({}, module.default)
          this.changeVideo(module.default.video_principal)
          this.footer.info.show = true
          this.showLoading = false
        } else {
          this.changeVideo(module.default.video_principal)
          this.setVideoData(module.default)
        }
      } catch (error) {
        this.changeToSupport()
      }
    },

    openTutorial () {
      window.open(this.buttonSecondary.link.src, '_blank')
    },

    openZendesk () {
      this.$modal.closeModal()
      this.$zendesk.zE('webWidget', 'toggle')
    },

    setVideoData (videoData) {
      this.changeVideo(videoData.video_principal)
      this.section.info.text = videoData.link_pasoapaso[0]
      this.section.info.link = videoData.link_pasoapaso[1]
      this.section.download.text = videoData.link_descarga[0]
      this.section.download.src = videoData.link_descarga[1]
      this.buttonSecondary.link.text = videoData.link_pregunta[0]
      this.buttonSecondary.link.src = videoData.link_pregunta[1]
      videoData.galeria.forEach((video, index) => {
        this.loadThumbnail(video, index)
      })
      this.showLoading = false
    },

    async loadThumbnail (video, index) {
      try {
        const thumbnail = await this.getVimeoThumbnail(video)

        // Si la miniatura no se pudo obtener, asignar un placeholder
        const galleryVideo = {
          alt: `Video ${index}`,
          src: video,
          thumbnail: thumbnail || '@/assets/img/ds2.png' // Imagen de fallback
        }

        // Asegurar que el array está inicializado
        if (!Array.isArray(this.section.gallery.thumbnail)) {
          this.$set(this.section.gallery, 'thumbnail', [])
        }

        // Asegurar que el índice no está vacío antes de sobrescribir
        if (!this.section.gallery.thumbnail[index]) {
          this.$set(this.section.gallery.thumbnail, index, galleryVideo)
        } else {
          Object.assign(this.section.gallery.thumbnail[index], galleryVideo)
        }
      } catch (error) {
        console.error(`Error al obtener la miniatura para el video ${index}:`, error)
      }
    }
  }
}
</script>
